var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"search-bar",attrs:{"type":"text","placeholder":[[ _vm.$t('sharedSearchBar') ]]},on:{"input":_vm.update}})}
var staticRenderFns = []

export { render, staticRenderFns }